import { css } from '@emotion/react';
// import style from "../../../shared/global.style";

const filterAndPageSizeContainer = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 15px;
  > form {
    margin-left: auto;
  }
`;

const tableContainer = css`
  position: relative;
  background-color: var(--jbmp-white-color);
  overflow: auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  && {
    > table {
      border: none;
      box-shadow: none;

      > tbody {
        > tr:last-child {
          box-shadow: 0 1px 0 0 var(--jbmp-primary-color-10);
        }
      }
    }
  }
`;

const paginationContainer = css`
  && {
    border: none;
    border-top: 1px solid var(--jbmp-primary-color-20);
    border-radius: 0;
    background: var(--jbmp-white-color);
    border-bottom: 1px solid var(--jbmp-primary-color-20);
    flex-wrap: wrap;
    flex-shrink: 0;
  }
`;

const textAreaCell = css`
  overflow-wrap: break-word;
  white-space: break-spaces;
  overflow: hidden;
`;

export default {
  filterAndPageSizeContainer,
  tableContainer,
  paginationContainer,
  textAreaCell,
};
